import React, { useEffect, useState, useRef } from 'react';
import {
    Box, Stack, Grid, FormControl, InputLabel,
    MenuItem, Select, Pagination, CircularProgress,
    Button, Alert, Snackbar, TextField, Dialog, DialogContent,
    DialogActions, DialogTitle, Autocomplete
} from '@mui/material';

import { useEvent } from '../../contexts/event.context';
import { useAuth } from '../../contexts/auth.context';
import TableInfo from '../../components/TableInfo';
import api from '../../services/api';
import * as qs from 'qs';
import { format, parseISO } from 'date-fns';
import { maskCPF2 } from '../../utils/mask';
import XLSX from 'xlsx';

export default function Inscritos() {
    const [subscribers, setSubscribers] = useState([])
    const { basePath } = useAuth();
    const [page, setPage] = useState(1)
    const [loading, setLoading] = useState(false)
    const [eventSelected, setEventSelected] = useState()
    const [selectedCompany, setSelectedCompany] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [selectedState, setSelectedState] = useState('');
    const [companies, setCompanies] = useState([]);
    const [cities, setCities] = useState([]);
    const [states, setStates] = useState([]);
    const { events, getEvents, pagination, setPagination } = useEvent()
    const [renderExcel, setRenderExcel] = useState(false)
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [listCategories, setListCategory] = useState([]);
    const [searchName, setSearchName] = useState('');
    const [timer, setTimer] = useState(null)
    const [stateAlert, setStateAlert] = React.useState({ status: false, type: 'success', msg: '' });
    const [openEtiquetaDialog, setOpenEtiquetaDialog] = useState(false);
    const [intervaloInicio, setIntervaloInicio] = useState('');
    const [intervaloFim, setIntervaloFim] = useState('');
    const [todosSelecionado, setTodosSelecionado] = useState(false);
    const [selectedCpf, setSelectedCpf] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [loadingEvents, setLoadingEvents] = useState(false);
    const [hasMoreEvents, setHasMoreEvents] = useState(true);
    const [eventOptions, setEventOptions] = useState([])
    const pageEvents = useRef(1)

    const columnsSubscribers = [
        { Header: "Instituiçao", accessor: "company", width: "25%" },
        { Header: "Cidade", accessor: "locale", width: "20%" },
        { Header: "UF", accessor: "uf", width: "20%" },
        { Header: "Nome", accessor: "name", width: "20%" },
        { Header: "Cracha", accessor: "badge", width: "20%" },
        { Header: "Email", accessor: "email", with: "10%" },
        { Header: "Whatsapp", accessor: "whatsapp", width: "20%" },
        { Header: "CPF", accessor: "document", width: "10%" },
        { Header: "Etiqueta", accessor: "id", width: "10%" }
    ];

    async function changePage(newPage) {
        setCurrentPage(newPage);
        setPage(newPage);
        await handleSearch({
            event: eventSelected,
            category: selectedCategory,
            company: selectedCompany,
            city: selectedCity,
            state: selectedState,
            name: searchName,
            cpf: selectedCpf,
            nextPage: newPage
        });
    };

    async function handleExcelAgip() {
        if (!eventSelected) {
            setStateAlert({ ...stateAlert, status: true, type: 'warning', msg: `Nenhum evento selecionado para gerar planilha!` });
            return;
        };

        if (subscribers.length <= 0) {
            setStateAlert({ ...stateAlert, status: true, type: 'warning', msg: `Nenhuma lista de inscritos para gerar planilha!` });
            return;
        };

        setRenderExcel(true);
        let pageStream = 1
        const pageSize = 20; // Ajuste conforme necessário
        let allSubscribers = [];

        while (true) {
            let params = {
                sort: ['createdAt:desc'],
                pagination: { page: pageStream, pageSize },
                filters: {
                    deleted: { $eq: false },
                    event: { name: eventSelected },
                    plan: { type: { $contains: selectedCategory } }
                },
                populate: {
                    event: { fields: ['name'] },
                    plan: { fields: ['type'] },
                    company: { fields: ['city', 'state', 'social_reason'] },
                    subscribers: { fields: ['id', 'name', 'badge', 'document', 'whatsapp', 'email'] }
                },
                encodeValuesOnly: true
            };

            let query = qs.stringify(params, {
                skipNulls: false,
                skipUndefined: false,
                skipEmptyStrings: true
            });

            const response = await api.get(`/orders/?${query}`);
            const ordersData = response.data.data;

            if (!ordersData || ordersData.length === 0) break; // Sai do loop se não houver mais dados

            allSubscribers.push(...ordersData);
            pageStream++; // Avança para a próxima página
        };

        // Transforma os dados para a planilha
        const headers = [
            'CODIGO', 'INSTITUICAO', 'EVENTO', 'CIDADE', 'CATEGORIA', 'UF',
            'NOME', 'CRACHA', 'EMAIL', 'WHATSAPP', 'CPF', 'DATA_DE_INSCRICAO'
        ];

        const rows = allSubscribers.flatMap(order => {
            const company = order.attributes.company?.data?.attributes || {};
            const event = order.attributes.event?.data?.attributes || {};
            const plan = order.attributes.plan?.data?.attributes || {};
            const subscribers = order.attributes.subscribers?.data || [];

            return subscribers.map(sub => [
                sub.id,
                company.social_reason?.toUpperCase() || '',
                event.name?.toUpperCase() || '',
                company.city?.toUpperCase() || '',
                plan.type?.toUpperCase() || '',
                company.state?.toUpperCase() || '',
                sub.attributes.name?.toUpperCase() || '',
                sub.attributes.badge ? sub.attributes.badge.toUpperCase() : '',
                sub.attributes.email || '',
                sub.attributes.whatsapp || '',
                sub.attributes.document || '',
                format(parseISO(order.attributes.createdAt), 'dd/MM/yy HH:mm')
            ]);
        });

        // Cria e baixa o Excel
        const sheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
        const workBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workBook, sheet, 'inscricoes');
        setRenderExcel(false);
        return XLSX.writeFile(workBook, 'inscricoes.xlsx');
    };

    async function handleExcel() {
        if (!eventSelected) {
            setStateAlert({ ...stateAlert, status: true, type: 'warning', msg: `Nenhum evento selecionado para gerar planilha!` });
            return;
        };

        if (subscribers.length <= 0) {
            setStateAlert({ ...stateAlert, status: true, type: 'warning', msg: `Nenhuma lista de inscritos para gerar planilha!` });
            return;
        };
        try {
            setRenderExcel(true);
            let pageStream = 1
            const pageSize = 20; // Ajuste conforme necessário
            let allOrders = [];

            // Busca todos os inscritos (como já faz)
            while (true) {
                let params = {
                    sort: basePath == 'agip' ? ['createdAt:desc'] : ['subscribers.name:asc'],
                    pagination: { page: pageStream, pageSize },
                    filters: {
                        deleted: { $eq: false },
                        event: { name: eventSelected },
                        plan: {
                            type:
                            {
                                $contains: selectedCategory == 'CONGRESSITAS' ?
                                    ['RPPS de Outros Estados', 'RPPS não associado', 'RPPS associado', 'Órgãos Públicos (exceto Instituições Financeiras) ou Entes que não possuem RPPS'] : selectedCategory
                            }
                        }
                    },
                    populate: {
                        event: { fields: ['name'] },
                        plan: { fields: ['type'] },
                        company: { fields: ['city', 'state', 'social_reason'] },
                        subscribers: { fields: ['id', 'name', 'badge', 'document', 'whatsapp', 'email', 'state', 'city'] }
                    },
                    encodeValuesOnly: true
                };

                let query = qs.stringify(params, {
                    skipNulls: false,
                    skipUndefined: false,
                    skipEmptyStrings: true
                });

                const response = await api.get(`/orders/?${query}`);
                const ordersData = response.data.data;

                if (!ordersData || ordersData.length === 0) break; // Sai do loop se não houver mais dados
                allOrders.push(...ordersData);
                pageStream++; // Avança para a próxima página
            }

            // Extrai todos os subscribers de todas as ordens
            let allSubscribers = allOrders.flatMap(order => {
                return order.attributes.subscribers?.data.map(subscriber => ({
                    ...subscriber,
                    orderId: order.id,
                    orderCreatedAt: order.attributes.createdAt,
                    company: order.attributes.company?.data?.attributes || {},
                    event: order.attributes.event?.data?.attributes || {},
                    plan: order.attributes.plan?.data?.attributes || {}
                })) || [];
            });

            // Ordena alfabeticamente pelo nome do inscrito
            allSubscribers.sort((a, b) => {
                const nameA = a.attributes?.name?.toUpperCase() || '';
                const nameB = b.attributes?.name?.toUpperCase() || '';
                return nameA.localeCompare(nameB);
            });

            function generateSequentialCodeForSortedArray(sortedSubs) {
                const codeCounters = new Map();

                return sortedSubs.map(subObj => {
                    const name = subObj.attributes?.name;
                    const nameAlt = name?.trim()
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                        .toUpperCase() || '';
                    const codeLetter = nameAlt[0] || '#';

                    if (!codeCounters.has(codeLetter)) {
                        codeCounters.set(codeLetter, 0);
                    }

                    const nextNumber = codeCounters.get(codeLetter) + 1;
                    codeCounters.set(codeLetter, nextNumber);

                    return {
                        ...subObj,
                        CODE: `${codeLetter}${String(nextNumber)}`
                    };
                });
            };

            // Aplica a função para gerar os códigos
            const subscribersWithCode = generateSequentialCodeForSortedArray(allSubscribers);

            let freqPage = 1;
            const freqPageSize = 100;
            let allFrequencies = [];
            while (true) {
                const freqQuery = qs.stringify({
                    filters: { event: { name: eventSelected } },
                    pagination: { page: freqPage, pageSize: freqPageSize },
                    populate: { subscriber: { fields: ['id'] } },
                    encodeValuesOnly: true
                });
                const freqResp = await api.get(`/frequencies?${freqQuery}`);
                const freqData = freqResp.data.data;
                console.log(!freqData || freqData.length === 0);
                if (!freqData || freqData.length === 0) break;
                allFrequencies.push(...freqData);
                freqPage++;
            };

            // Cabeçalho com coluna PRESENÇA
            const headers = basePath == 'agip' ? [
                'ORDEM', 'CODIGO', 'INSTITUICAO', 'EVENTO', 'CIDADE', 'CATEGORIA', 'UF',
                'NOME', 'CRACHA', 'EMAIL', 'WHATSAPP', 'CPF', 'DATA_DE_INSCRICAO', 'ASSINATURA'
            ] : ['ORDEM', 'NOME', 'CRACHA', 'UF', 'CIDADE', 'CODIGO', 'ASSINATURA'];

            // Monta as linhas

            const rows = basePath == 'agip' ? subscribersWithCode.map(sub => {
                return [
                    sub.CODE || '', // Adiciona o código sequencial
                    sub.id,
                    sub.company.social_reason?.toUpperCase() || '',
                    sub.event.name?.toUpperCase() || '',
                    sub.company?.city?.toUpperCase() || sub.attributes?.city?.toUpperCase() || '',
                    sub.plan.type?.toUpperCase() || '',
                    sub.company?.state?.toUpperCase() || sub.attributes?.state?.toUpperCase() || '',
                    sub.attributes.name?.toUpperCase() || '',
                    sub.attributes.badge ? sub.attributes.badge.toUpperCase() : '',
                    sub.attributes.email || '',
                    sub.attributes.whatsapp || '',
                    sub.attributes.document || '',
                    format(parseISO(sub.orderCreatedAt), 'dd/MM/yy HH:mm'),
                    ""
                ];
            }) : subscribersWithCode.map(sub => {
                return [
                    sub.CODE || '',
                    sub.attributes.name?.toUpperCase() || '',
                    sub.attributes.badge ? sub.attributes.badge.toUpperCase() : '',
                    sub.company?.state?.toUpperCase() || sub.attributes?.state?.toUpperCase() || '',
                    sub.company?.city?.toUpperCase() || sub.attributes?.city?.toUpperCase() || '',
                    sub.id,
                    ""
                ]
            });

            // Cria e baixa o Excel
            const sheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
            const workBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workBook, sheet, 'inscricoes');
            setRenderExcel(false);
            return XLSX.writeFile(workBook, 'inscricoes.xlsx');
        } catch (error) {
            console.log(error)
            setRenderExcel(false)
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `Erro ao gerar planilha: ${error.message}` });
        };
    };

    async function handleExcelByLabels(inicio, fim, todos) {
        if (!eventSelected) {
            setStateAlert({ ...stateAlert, status: true, type: 'warning', msg: `Nenhum evento selecionado para gerar planilha!` });
            return;
        }

        if (subscribers.length <= 0) {
            setStateAlert({ ...stateAlert, status: true, type: 'warning', msg: `Nenhuma lista de inscritos para gerar planilha!` });
            return;
        }
        try {
            setRenderExcel(true);
            let pageStream = 1
            const pageSize = 20; // Ajuste conforme necessário
            let allOrders = [];

            // Busca todos os inscritos (como já faz)
            while (true) {
                let params = {
                    sort: basePath == 'agip' ? ['createdAt:desc'] : ['subscribers.name:asc'],
                    pagination: { page: pageStream, pageSize },
                    filters: {
                        deleted: { $eq: false },
                        event: { name: eventSelected },
                        plan: {
                            type:
                            {
                                $contains: selectedCategory == 'CONGRESSITAS' ?
                                    ['RPPS de Outros Estados', 'RPPS não associado', 'RPPS associado', 'Órgãos Públicos (exceto Instituições Financeiras) ou Entes que não possuem RPPS'] : selectedCategory
                            }
                        }
                    },
                    populate: {
                        event: { fields: ['name'] },
                        plan: { fields: ['type'] },
                        company: { fields: ['city', 'state', 'social_reason'] },
                        subscribers: { fields: ['id', 'name', 'badge', 'document', 'whatsapp', 'email'] }
                    },
                    encodeValuesOnly: true
                };

                let query = qs.stringify(params, {
                    skipNulls: false,
                    skipUndefined: false,
                    skipEmptyStrings: true
                });

                const response = await api.get(`/orders/?${query}`);
                const ordersData = response.data.data;

                if (!ordersData || ordersData.length === 0) break; // Sai do loop se não houver mais dados
                allOrders.push(...ordersData);
                pageStream++; // Avança para a próxima página
            }

            // Extrai todos os subscribers de todas as ordens
            let allSubscribers = allOrders.flatMap(order => {
                return order.attributes.subscribers?.data.map(subscriber => ({
                    ...subscriber,
                    orderId: order.id,
                    orderCreatedAt: order.attributes.createdAt,
                    company: order.attributes.company?.data?.attributes || {},
                    event: order.attributes.event?.data?.attributes || {},
                    plan: order.attributes.plan?.data?.attributes || {}
                })) || [];
            });
            // Filtrar por intervalo alfabético
            allSubscribers = allSubscribers.filter(sub => {
                const firstLetter = sub.attributes?.name?.charAt(0).toUpperCase() || '';
                if (todos) return true;
                return firstLetter >= inicio.toUpperCase() && firstLetter <= fim.toUpperCase();
            });

            // Ordena alfabeticamente pelo nome do inscrito
            allSubscribers.sort((a, b) => {
                const nameA = a.attributes?.name?.toUpperCase() || '';
                const nameB = b.attributes?.name?.toUpperCase() || '';
                return nameA.localeCompare(nameB);
            });

            // Função para gerar código sequencial
            function generateSequentialCodeForSortedArray(sortedSubs, start, end) {
                const codeCounters = new Map();

                return sortedSubs.map(subObj => {
                    const name = subObj.attributes?.name;
                    const nameAlt = name?.trim()
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                        .toUpperCase() || '';
                    const codeLetter = nameAlt[0] || '#';

                    // Verifica se a letra está no intervalo
                    if (codeLetter >= start.toUpperCase() &&
                        codeLetter <= (end.toUpperCase() || start.toUpperCase())) {

                        if (!codeCounters.has(codeLetter)) {
                            codeCounters.set(codeLetter, 0);
                        }

                        const nextNumber = codeCounters.get(codeLetter) + 1;
                        codeCounters.set(codeLetter, nextNumber);

                        return {
                            ...subObj,
                            CODE: `${codeLetter}${String(nextNumber)}`
                        };
                    }

                    return subObj; // Retorna o objeto sem código se estiver fora do intervalo
                });
            }

            // Aplica a função para gerar os códigos
            const subscribersWithCode = generateSequentialCodeForSortedArray(allSubscribers, inicio,
                fim);

            let freqPage = 1;
            const freqPageSize = 100;
            let allFrequencies = [];
            while (true) {
                const freqQuery = qs.stringify({
                    filters: { event: { name: eventSelected } },
                    pagination: { page: freqPage, pageSize: freqPageSize },
                    populate: { subscriber: { fields: ['id'] } },
                    encodeValuesOnly: true
                });
                const freqResp = await api.get(`/frequencies?${freqQuery}`);
                const freqData = freqResp.data.data;
                console.log(!freqData || freqData.length === 0);
                if (!freqData || freqData.length === 0) break;
                allFrequencies.push(...freqData);
                freqPage++;
            }

            // Cabeçalho com coluna PRESENÇA
            const headers = basePath == 'agip' ? [
                'ORDEM', 'CODIGO', 'INSTITUICAO', 'EVENTO', 'CIDADE', 'CATEGORIA', 'UF',
                'NOME', 'CRACHA', 'EMAIL', 'WHATSAPP', 'CPF', 'DATA_DE_INSCRICAO', 'ASSINATURA'
            ] : ['ORDEM', 'NOME', 'CRACHA', 'UF', 'CIDADE', 'CODIGO', 'ASSINATURA'];

            // Monta as linhas

            const rows = basePath == 'agip' ? subscribersWithCode.map(sub => {
                return [
                    sub.CODE || '', // Adiciona o código sequencial
                    sub.id,
                    sub.company.social_reason?.toUpperCase() || '',
                    sub.event.name?.toUpperCase() || '',
                    sub.company.city?.toUpperCase() || '',
                    sub.plan.type?.toUpperCase() || '',
                    sub.company.state?.toUpperCase() || '',
                    sub.attributes.name?.toUpperCase() || '',
                    sub.attributes.badge ? sub.attributes.badge.toUpperCase() : '',
                    sub.attributes.email || '',
                    sub.attributes.whatsapp || '',
                    sub.attributes.document || '',
                    format(parseISO(sub.orderCreatedAt), 'dd/MM/yy HH:mm'),
                    ""
                ];
            }) : subscribersWithCode.map(sub => {
                return [
                    sub.CODE || '',
                    sub.attributes.name?.toUpperCase() || '',
                    sub.attributes.badge ? sub.attributes.badge.toUpperCase() : '',
                    sub.company.state?.toUpperCase() || '',
                    sub.company.city?.toUpperCase() || '',
                    sub.id,
                    ""
                ]
            });

            // Cria e baixa o Excel
            const sheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
            const workBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workBook, sheet, 'inscricoes');
            setRenderExcel(false);
            return XLSX.writeFile(workBook, 'inscricoes.xlsx');
        } catch (error) {
            console.log(error)
            setRenderExcel(false)
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `Erro ao gerar planilha: ${error.message}` });
        }
    };

    async function handleImprimirEtiquetas(inicio, fim, todos) {
        let evento = eventOptions.find(evt => evt.attributes.name === eventSelected);
        if (todos) {
            await generateLabels({ event: evento.id, category: selectedCategory, start: "A", end: "Z" });
            await handleExcelByLabels("A", "Z", true);
        } else {
            console.log(inicio, fim)
            const start = inicio.toUpperCase();
            const end = fim.toUpperCase();
            await generateLabels({ event: evento.id, category: selectedCategory, start, end });
            await handleExcelByLabels(start, end, false);
        }
    };

    async function printLabel(subscriberId) {
        setRenderExcel(true);
        if (subscriberId) {
            try {
                const response = await api.post(`order/label`, { subscriber: subscriberId })

                if (response.status === 200) {
                    const base64Pdf = response.data.pdf;
                    const url = `data:application/pdf;base64,${base64Pdf}`;
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = `etiqueta-${subscriberId}.pdf`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                    setRenderExcel(false)
                }
            } catch (error) {
                console.log(error)
                setRenderExcel(false)
                setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `Erro ao gerar etiquetas: ${error.message}` });
            }
        } else {
            setRenderExcel(false)
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `Erro ao selecionar o Inscrito` });
        };

    };

    async function generateLabels({ event, category, start, end }) {
        setRenderExcel(true)
        if (!event) {
            setRenderExcel(false)
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `Evento não selecionado` });
            return
        }
        try {
            console.log(start, end)
            const response = await api.post(`order/labels/${event}`, { category, start, end })

            if (response.status === 200) {
                const base64Pdf = response.data.pdf;
                const url = `data:application/pdf;base64,${base64Pdf}`;
                const link = document.createElement('a');
                link.href = url;
                link.download = `etiquetas-${event}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
                setRenderExcel(false)
            }
        } catch (error) {
            console.log(error)
            setRenderExcel(false)
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `Erro ao gerar etiquetas: ${error.message}` });
        }

    };

    async function handleSearch({ event, category, company, city, state, name, cpf, nextPage }) {
        setEventSelected(event);
        setLoading(true);
        if (!event) {
            setLoading(false);
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `Evento não selecionado` });
            return;
        }
        console.log('nextpage', nextPage)
        if (!nextPage) setPage(1);
        let query = qs.stringify({
            filters: {
                deleted: { $eq: false },
                event: { name: event },
                plan: {
                    type: {
                        $contains: category == 'CONGRESSISTAS' ? ['RPPS de Outros Estados', 'RPPS não associado', 'RPPS associado', 'Órgãos Públicos (exceto Instituições Financeiras) ou Entes que não possuem RPPS'] : category,
                    }
                },
                company: {
                    social_reason: company ? { $containsi: company } : undefined,
                    city: city ? { $eq: city } : undefined,
                    state: state ? { $eq: state } : undefined,
                },
                subscribers: {
                    name: name ? { $containsi: name } : undefined, // Filtra pelo nome do inscrito
                    document: cpf ? { $containsi: cpf } : undefined, // Filtra pelo CPF do inscrito
                },
            },
            sort: basePath == 'agip' ? ['createdAt:desc'] : ['subscribers.name:asc'],
            populate: {
                event: { fields: ['name'] },
                plan: { fields: ['type'] },
                company: { fields: ['city', 'state', 'social_reason'] },
                subscribers: { fields: ['id', 'name', 'badge', 'document', 'whatsapp', 'email', 'city', 'state', 'birth'] },
            },
            pagination: {
                pageSize: basePath == 'agip' ? 10 : 50,
                page: nextPage || 1,
            },
            encodeValuesOnly: true,
        });

        if (!event) return;

        try {
            const foundedSubscribers = await api.get('/orders?' + query);
            setPagination(foundedSubscribers.data.meta.pagination);
            console.log(foundedSubscribers.data.meta.pagination)
            let subs = [];
            let subscribersOrder = [];

            if (foundedSubscribers.status === 200) {
                subs = [...foundedSubscribers.data.data];
                subs.forEach((subscriber, index) => {
                    subscriber.attributes.subscribers.data.forEach((sub) => {
                        if (name.length > 0 && sub.attributes.name.toUpperCase().includes(name.toUpperCase())) {
                            sub.attributes.event = subs[index].attributes.event.data.attributes.name;
                            sub.attributes.locale = subs[index].attributes?.company?.data?.attributes?.city.toUpperCase() || sub.attributes?.city?.toUpperCase() || '';
                            sub.attributes.uf = subs[index].attributes?.company?.data?.attributes?.state.toUpperCase() || sub.attributes?.state?.toUpperCase() || '';
                            sub.attributes.company = subs[index].attributes?.company?.data?.attributes?.social_reason.toUpperCase() || 'Sem Instituição';
                            sub.attributes.badge = sub.attributes.badge ? sub.attributes.badge.toUpperCase() : "------";
                            subscribersOrder.push(sub);
                        } else if (!name) {
                            sub.attributes.event = subs[index].attributes.event.data.attributes.name;
                            sub.attributes.locale = subs[index].attributes?.company?.data?.attributes?.city.toUpperCase() || sub.attributes?.city?.toUpperCase() || '';
                            sub.attributes.uf = subs[index].attributes?.company?.data?.attributes?.state.toUpperCase() || sub.attributes?.state?.toUpperCase() || '';
                            sub.attributes.company = subs[index].attributes?.company?.data?.attributes?.social_reason.toUpperCase() || 'Sem Instituição';
                            sub.attributes.badge = sub.attributes.badge ? sub.attributes.badge.toUpperCase() : "------";
                            subscribersOrder.push(sub);
                        }
                    });
                });

                setSubscribers([...subscribersOrder]);
                setSelectedCategory(category)
                setSelectedCity(city)
                setSelectedState(state)
                setSelectedCompany(company)
                setSearchName(name)
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };

    async function handleSubscribers(nextPage) {
        setLoading(true)
        let query = qs.stringify({
            filters: {
                deleted: {
                    $eq: false
                },
                event: {
                    name: eventSelected
                },
            },
            sort: basePath == 'agip' ? ['createdAt:desc'] : ['subscribers.name:asc'],
            fields: ['id', ' transaction'],
            populate: {
                event: {
                    fields: ['name']
                },
                company: {
                    fields: ['city', 'state', 'social_reason']
                },
                plans: {
                    populate: '*'
                },
                subscribers: {
                    fields: ['id', 'name', 'badge', 'document', 'whatsapp', 'email']
                }

            },
            pagination: {
                pageSize: 10,
                page: nextPage || page,
            },
            encodeValuesOnly: true,

        })
        try {
            const foundedSubscribers = await api.get('/orders?' + query)
            setPagination(foundedSubscribers.data.meta.pagination)
            let subs = []
            let subscribersOrder = []
            if (foundedSubscribers.status === 200) {
                subs = [...foundedSubscribers.data.data]
                // eslint-disable-next-line array-callback-return
                subs.map((subscriber, index) => {
                    subs[index].attributes.subscribers.data.map(sub => {
                        sub.attributes.event = subs[index].attributes.event.data.attributes.name
                        sub.attributes.locale = subs[index].attributes.company.data.attributes.city.toUpperCase()
                        sub.attributes.uf = subs[index].attributes.company.data.attributes.state.toUpperCase()
                        sub.attributes.company = subs[index].attributes.company.data.attributes.social_reason.toUpperCase()
                        sub.attributes.badge = sub.attributes.badge ? sub.attributes.badge.toUpperCase() : "------"
                        subscribersOrder.push(sub)
                    })
                })
                setSubscribers([...subscribersOrder])
                setLoading(false)
            }
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    };

    async function fetchFilters() {
        let pageStream = 1;
        const pageSize = 200; // Ajuste conforme necessário
        const allCompanies = [];
        const allCities = new Set();
        const allStates = new Set();

        try {
            while (true) {
                let query = qs.stringify({
                    fields: ['id'],
                    filters: {
                        deleted: { $eq: false },
                        event: { name: eventSelected },
                    },
                    sort: ['createdAt:desc'],
                    populate: {
                        event: { fields: ['name'] },
                        company: { fields: ['city', 'state', 'social_reason'] },
                    },
                    pagination: { pageSize, page: pageStream },
                    encodeValuesOnly: true,
                });

                const { data } = await api.get('/orders?' + query);
                if (!data.data || data.data.length === 0) break; // Sai do loop se não houver mais dados

                // Processa os dados da página atual
                data.data.forEach((order) => {
                    const company = order.attributes.company?.data;
                    if (company) {
                        allCompanies.push(company);
                        allCities.add(company.attributes.city);
                        allStates.add(company.attributes.state);
                    }
                });

                pageStream++;
            }

            // Remove duplicatas de empresas
            const uniqueCompanies = Array.from(
                allCompanies.reduce((map, current) => {
                    if (!map.has(current.attributes.social_reason)) {
                        map.set(current.attributes.social_reason, { id: current.id, social_reason: current.attributes.social_reason });
                    }
                    return map;
                }, new Map())
            ).map(([key, value]) => value);

            // Converte os conjuntos para arrays
            const uniqueCities = Array.from(allCities);
            const uniqueStates = Array.from(allStates);

            // Atualiza os estados apenas uma vez
            setCompanies(uniqueCompanies);
            setCities(uniqueCities);
            setStates(uniqueStates);

        } catch (error) {
            console.error('Erro ao carregar filtros:', error);
            setStateAlert({
                status: true,
                type: 'error',
                msg: `Erro ao carregar filtros: ${error.message}`,
            });
        }
    };

    /*useEffect(() => {
        if (eventSelected && eventSelected?.length > 0) {
            console.log('eventSelected', eventSelected)
            console.log('eventOptions', eventOptions.find(e => e.attributes?.name === eventSelected))
            eventOptions.map(evento => {
                if (evento.attributes.name == eventSelected) {
                    console.log('evento.attributes.plans.data', evento.attributes.plans.data)
                    setListCategory(evento.attributes.plans.data)
                }
            })
            fetchFilters()
        }
    }, [eventSelected])*/

    useEffect(() => {
        handleSubscribers()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    async function loadMoreEvents() {
        if (!hasMoreEvents || loadingEvents) return;

        setLoadingEvents(true);
        try {
            await getEvents(pageEvents.current + 1, pagination.pageSize, true);
            setEventOptions(prev => [...prev, ...events]);
        } catch (error) {
            console.error('Erro ao carregar eventos:', error);
        } finally {
            setLoadingEvents(false);
        }
    }
    return (
        <Box sx={{ width: '100%', height: '100vh' }} p={3}>
            <Stack direction="row" alignItems="center" justifyContent={'flex-start'} spacing={2} mx={9}>
                <Snackbar
                    open={stateAlert.status}
                    autoHideDuration={2500}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    onClose={() => setStateAlert({ status: false, type: 'success', msg: '' })} >
                    <Alert sx={{ width: '100%' }} severity={`${stateAlert.type}`}>
                        {stateAlert.msg}
                    </Alert>
                </Snackbar>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={2}>
                        <FormControl fullWidth>
                            <Autocomplete
                                id="select-event-infinite-scroll"
                                options={eventOptions}
                                loading={loadingEvents}
                                getOptionLabel={(option) => option.attributes?.name || ''}
                                value={eventOptions.find(e => e.attributes?.name === eventSelected) || null}
                                onChange={(_, newValue) => {
                                    pageEvents.current = 1;
                                    setEventSelected(newValue?.attributes?.name || '');
                                    console.log('planos: ', newValue?.attributes?.plans?.data || []);
                                    setListCategory(newValue?.attributes?.plans?.data || []);
                                    setSelectedCategory("");
                                    setSelectedCompany(null);
                                    setSelectedState("");
                                    setSelectedCity("");
                                    setSearchName("");
                                    handleSearch({ event: newValue?.attributes?.name || '', category: "", name: "", company: "", state: "", city: "" });

                                    document.getElementById('select-event-infinite-scroll').value = '';
                                }}
                                onOpen={() => {
                                    if (eventOptions.length === 0) {
                                        loadMoreEvents();
                                    }
                                }}
                                ListboxProps={{
                                    onScroll: (event) => {
                                        const listbox = event.currentTarget;
                                        if (
                                            listbox.scrollTop + listbox.clientHeight >= listbox.scrollHeight - 10 &&
                                            hasMoreEvents &&
                                            !loadingEvents
                                        ) {
                                            loadMoreEvents();
                                        }
                                    },
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Selecionar Evento"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <React.Fragment>
                                                    {loadingEvents ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </React.Fragment>
                                            ),
                                        }}
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <FormControl fullWidth >
                            <InputLabel id="select-category">Selecionar Categoria:</InputLabel>
                            <Select
                                labelId="select-category"
                                id="select-category"
                                value={selectedCategory}
                                onChange={(event) => {
                                    setPage(1);
                                    setSelectedCategory(event.target.value);
                                    handleSearch({ event: eventSelected, category: event.target.value, name: searchName, company: selectedCompany, state: selectedState, city: selectedCity })
                                }
                                }
                                label="Selecionar Categoria"
                            >
                                <MenuItem value="">
                                    <em>Nenhum</em>
                                </MenuItem>
                                {listCategories.length > 0 &&
                                    <MenuItem key={'CONGRESSITAS'} value="CONGRESSISTAS">CONGRESSISTAS</MenuItem>
                                }
                                {listCategories.length > 0 && listCategories.map(plan =>
                                    <MenuItem key={plan.id} value={plan.attributes.type}>{plan.attributes.type}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <FormControl fullWidth>
                            <TextField
                                label="Buscar por Nome do Inscrito"
                                variant="outlined"
                                value={searchName}
                                onChange={(event) => {
                                    clearTimeout(timer);
                                    console.log(event.target.value)
                                    setSearchName(event.target.value);
                                    if (!event.target.value && searchName.length > 0) {
                                        handleSearch({ event: eventSelected, category: selectedCategory, name: "", company: selectedCompany, state: selectedState, city: selectedCity })
                                    }
                                    if (!event.target.value) return;
                                    const newTimer = setTimeout(() => handleSearch({ event: eventSelected, category: selectedCategory, name: event.target.value, company: selectedCompany, state: selectedState, city: selectedCity }), 1500);
                                    setTimer(newTimer);
                                }}
                                placeholder="Digite o nome do inscrito"
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <FormControl fullWidth>
                            <Autocomplete
                                id="autocomplete-company"
                                options={companies}
                                getOptionLabel={(option) => option?.social_reason || ''}
                                value={companies.find(c => c.social_reason === selectedCompany) || null}
                                onChange={(_, value) => {
                                    setSelectedCompany(value ? value.social_reason : '');
                                    handleSearch({
                                        event: eventSelected,
                                        category: selectedCategory,
                                        company: value ? value.social_reason : '',
                                        name: searchName,
                                        state: selectedState,
                                        city: selectedCity
                                    });
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Selecionar Empresa" variant="outlined" />
                                )}
                                isOptionEqualToValue={(option, value) => option?.social_reason === value?.social_reason}
                                clearOnEscape
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={1}>
                        <FormControl fullWidth>
                            <InputLabel id="select-city">Selecionar Cidade:</InputLabel>
                            <Select
                                labelId="select-city"
                                id="select-city"
                                value={selectedCity}
                                onChange={(event) => {
                                    setSelectedCity(event.target.value);
                                    handleSearch({ event: eventSelected, category: selectedCategory, city: event.target.value, name: searchName, state: selectedState, company: selectedCompany });
                                }}
                                label="Selecionar Cidade"
                            >
                                <MenuItem value="">
                                    <em>Todas</em>
                                </MenuItem>
                                {cities.map((city) => (
                                    <MenuItem key={city} value={city}>
                                        {city}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={1}>
                        <FormControl fullWidth>
                            <InputLabel id="select-state">Selecionar Estado:</InputLabel>
                            <Select
                                labelId="select-state"
                                id="select-state"
                                value={selectedState}
                                onChange={(event) => {
                                    setSelectedState(event.target.value);
                                    handleSearch({ event: eventSelected, category: selectedCategory, name: searchName, city: selectedCity, company: selectedCompany, state: event.target.value });
                                }}
                                label="Selecionar Estado"
                            >
                                <MenuItem value="">
                                    <em>Todos</em>
                                </MenuItem>
                                {states.map((state) => (
                                    <MenuItem key={state} value={state}>
                                        {state}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={1}>
                        <FormControl fullWidth>
                            <TextField
                                label="Buscar por CPF"
                                variant="outlined"
                                value={selectedCpf}
                                onChange={(event) => {
                                    const maskedCpf = maskCPF2(event.target.value);
                                    event.target.value = maskedCpf; // Atualiza o valor do input com a máscara aplicada
                                    clearTimeout(timer);
                                    console.log(event.target.value);
                                    setSelectedCpf(event.target.value);

                                    handleSearch({ event: eventSelected, category: selectedCategory, city: selectedCity, name: searchName, state: selectedState, company: selectedCompany, cpf: event.target.value });
                                }}
                                placeholder="Digite o CPF"
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={1}>
                        <Button sx={{ minWidth: 190, mt: -2 }} variant='contained' color='success' onClick={() => basePath == 'agip' ? handleExcelAgip() : handleExcel()} disabled={renderExcel}>
                            {renderExcel ? <CircularProgress sx={{ alignSelf: 'center' }} size={20} /> : "Exportar Excel"} </Button>
                        <Button sx={{ minWidth: 190, mt: 1 }} variant='contained' color='warning' onClick={(event) => setOpenEtiquetaDialog(true)} disabled={renderExcel}>
                            {renderExcel ? <CircularProgress sx={{ alignSelf: 'center' }} size={20} /> : "Gerar Etiquetas"} </Button>
                    </Grid>
                </Grid>
            </Stack>
            <Grid container py={3}>
                {loading ?
                    <Box sx={{ width: '100%', height: '10vh', display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress sx={{ alignSelf: 'center' }} size={50} />
                    </Box>
                    :
                    <TableInfo title='Inscritos' variant="info" rows={subscribers} columns={columnsSubscribers} printLabel={printLabel} />
                }
            </Grid>

            <Stack direction="row" alignItems="center" justifyContent={'flex-end'} spacing={2} mx={10}>
                <Pagination count={pagination.pageCount} defaultPage={1} color="primary" page={currentPage}
                    onChange={(event, value) => { setCurrentPage(value); changePage(value); }} />
            </Stack>
            <Dialog open={openEtiquetaDialog} onClose={() => setOpenEtiquetaDialog(false)}>
                <DialogTitle>Escolha o intervalo alfabético</DialogTitle>
                <DialogContent>
                    <Box display="flex" gap={2} alignItems="center" mb={2}>
                        <TextField
                            label="Início"
                            sx={{ m: 1 }}
                            value={intervaloInicio}
                            onChange={e => {
                                setIntervaloInicio(e.target.value.toUpperCase().replace(/[^A-Z]/g, '').slice(0, 1));
                                setTodosSelecionado(false);
                            }}
                            disabled={todosSelecionado}
                            inputProps={{ maxLength: 1 }}
                        />
                        <TextField
                            label="Fim"
                            sx={{ m: 1 }}
                            value={intervaloFim}
                            onChange={e => {
                                setIntervaloFim(e.target.value.toUpperCase().replace(/[^A-Z]/g, '').slice(0, 1));
                                setTodosSelecionado(false);
                            }}
                            disabled={todosSelecionado}
                            inputProps={{ maxLength: 1 }}
                        />
                        <FormControl fullWidth >
                            <InputLabel id="select-category">Selecionar Categoria:</InputLabel>
                            <Select
                                labelId="select-category"
                                id="select-category"
                                value={selectedCategory}
                                onChange={(event) => {
                                    setPage(1);
                                    setSelectedCategory(event.target.value);
                                    handleSearch({ event: eventSelected, category: event.target.value, name: searchName, company: selectedCompany, state: selectedState, city: selectedCity })
                                }
                                }
                                label="Selecionar Categoria"
                            >
                                <MenuItem value="">
                                    <em>Nenhum</em>
                                </MenuItem>
                                <MenuItem key={'CONGRESSISTAS'} value="CONGRESSISTAS">CONGRESSISTAS</MenuItem>
                                {listCategories.length > 0 && listCategories.map(plan =>
                                    <MenuItem key={plan.id} value={plan.attributes.type}>{plan.attributes.type}</MenuItem>
                                )}

                            </Select>
                        </FormControl>
                        <Button
                            variant={todosSelecionado ? "contained" : "outlined"}
                            color="secondary"
                            size='large'
                            onClick={() => {
                                setTodosSelecionado(prev => !prev);
                                setIntervaloInicio('');
                                setIntervaloFim('');
                            }}
                        >
                            Todos
                        </Button>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        setOpenEtiquetaDialog(false)
                        setTodosSelecionado(false);
                    }} color="inherit">
                        Cancelar
                    </Button>
                    <Button
                        onClick={() => {
                            handleImprimirEtiquetas(intervaloInicio, intervaloFim, todosSelecionado);
                            setOpenEtiquetaDialog(false);
                            setTodosSelecionado(false);
                        }}
                        color="primary"
                        variant="contained"
                        disabled={!todosSelecionado && (!intervaloInicio || !intervaloFim)}
                    >
                        Imprimir
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}